import styled from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import LoaderSkeleton from '@tcp/core/src/components/common/molecules/LoaderSkelton';

export const StyledOutfitContainer = styled.div`
  margin: 0 21px 0 21px;
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    margin: 0 24px 0 24px;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    margin: 24px;
  }
`;

export const StyledOutfitProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    flex-direction: row;
    gap: 32px;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    gap: 37px;
    flex-direction: row;
  }
`;

export const StyledOutfitList = styled.ul`
  &.products-list-grid {
    display: grid;
    width: 100%;
    grid-column-gap: 16px;
    grid-row-gap: 24px;
    grid-template-columns: repeat(auto-fill, minmax(163px, 1fr));
    margin-top: 16px;

    @media ${(props) => props.theme.mediaQuery.medium} {
      grid-column-gap: 15px;
      margin: 0;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      width: 55%;
      grid-column-gap: 48px;
      grid-row-gap: 48px;
      grid-template-columns: 264px 264px;
    }
  }
  &.grid-product-skelton-view {
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: fit-content;
    }
    flex-grow: 1;
    @media ${(props) => props.theme.mediaQuery.large} {
      grid-column-gap: 48px;
      grid-row-gap: 48px;
      grid-template-columns: 264px 264px;
    }
  }
`;

export const StyledBreadcrumbsContainer = styled.div`
  margin-bottom: 16px;
  @media ${(props) => props.theme.mediaQuery.large} {
    margin-bottom: 32px;
  }
`;

// TODO: get the colors from theme.
export const StyledPager = styled(BodyCopy)`
  margin-bottom: 16px;
  color: #595959;
`;

export const StyledOutfitCarouselContainer = styled.div`
  position: relative;
`;

export const StyledItemsInThisLookLabel = styled(BodyCopy)`
  display: contents;
  padding-bottom: 16px;
  @media ${(props) => props.theme.mediaQuery.medium} {
    display: none;
  }
`;

export const StyledProductTileSkeleton = styled(LoaderSkeleton)`
  height: 360px;
  @media ${(props) => props.theme.mediaQuery.large} {
    height: 470px;
  }
`;

export const StyledRecommendationsContainer = styled.div`
  & .recommendations-tile-new .recommendations-wrapper {
    margin-right: 0px;
    margin-left: 0px;
    width: 100%;

    .recommendation-tile {
      @media (min-width: 860px) and (max-width: 915px),
        (min-width: 1024px) and (max-width: 1100px) {
        flex: 0 0 173px;
        min-height: 312px;
      }

      @media (min-width: 500px) and (max-width: 565px), (min-width: 680px) and (max-width: 740px), {
        flex: 0 0 176px;
        min-height: 316px;
      }

      @media (min-width: 360px) and (max-width: 400px) {
        flex: 0 0 143px;
        min-height: 274px;
      }
    }
  }
`;

export const StyledOufitListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledItemsUnavailableWrapper = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
  margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  column-gap: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  border: 1px solid ${(props) => props.theme.colorPalette.red[300]};
  border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
`;

export const StyledItemsUnavailableText = styled(BodyCopy)`
  line-height: ${(props) => props.theme.spacing.ELEM_SPACING.MED_1};
`;
